import { render, staticRenderFns } from "./GeneralIndustryDashboard.vue?vue&type=template&id=47924ac0&scoped=true"
import script from "./GeneralIndustryDashboard.vue?vue&type=script&lang=js"
export * from "./GeneralIndustryDashboard.vue?vue&type=script&lang=js"
import style0 from "./GeneralIndustryDashboard.vue?vue&type=style&index=0&id=47924ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47924ac0",
  null
  
)

export default component.exports